import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

/**
 * Labeled count summary for cart/detail footers, product headers, and grid recap.
 * Edit this component to restore products / variants.
 */
const BulkOrderCountSummary = ({ pieceCount }) => {
  const { t } = useTranslation()
  // Show only pieces for now. To restore full summary, accept productCount / variantCount and return:
  // `${productCount} ${t('products')} · ${variantCount} ${t('variants')} · ${pieceCount} ${t('pieces')}`
  return `${pieceCount} ${t('pieces')}`
}

BulkOrderCountSummary.propTypes = {
  productCount: PropTypes.number,
  variantCount: PropTypes.number,
  pieceCount: PropTypes.number.isRequired,
}

export default BulkOrderCountSummary
